import axios, { AxiosResponse } from "axios";
import { IMsalContext } from "@azure/msal-react";
import { getAccessToken } from "config/token";

export interface IDeleteFsxPayload {
  space_name: string;
}

export interface IDeleteFsxResponse {
  success: boolean;
  message: string;
  [key: string]: any;
}

export const deleteCustomAttachedFilesystem = async (
  msalInstance: IMsalContext,
  payload: IDeleteFsxPayload,
): Promise<IDeleteFsxResponse> => {
  try {
    const token = await getAccessToken(msalInstance);
    const bearerToken = "Bearer " + (token == undefined ? "" : token.token);

    const requestURL = `${process.env.REACT_APP_NEXUS_API_BASE_URL}/filesystem/delete-custom-attached-filesystem`;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: bearerToken,
      },
    };

    const response: AxiosResponse<IDeleteFsxResponse> = await axios.post(
      requestURL,
      payload,
      config,
    );

    return response.data;
  } catch (err) {
    console.error("Error deleting FSx file system:", err);

    if (axios.isAxiosError(err)) {
      console.error(
        "[deleteCustomAttachedFilesystem] ERROR (Axios):",
        err.response?.status,
        err.response?.data,
        err.message,
      );
    }

    throw err;
  }
};
